export function handleReloadEvent() {
  window.location.reload();
}
